import { LaunchpadCard } from 'src/components/ui/LaunchpadCard';
import { NumberOfRoomsTextField } from '../atomic-components/NumberOfRoomsTextField';
import { RealestateSizeTextField } from '../atomic-components/RealestateSizeTextField';
import { BuildingConditionSelector } from '../atomic-components/BuildingConditionSelector';
import { RealEstatesPropertyTypeSelector } from '../addedit-forms/RealEstatePropertyTypeSelector';
import { HeatingTypeSelector } from '../atomic-components/HeatingTypeSelector';
import { CarbonEmissionTextField } from '../atomic-components/CarbonEmissionTextField';
import { EnergyEmissionTextField } from '../atomic-components/EnergyEmissionTextField';
import { AssetFeatureSelector } from '../atomic-components/AssetFeatureSelector';
import { ConstructionStatusSelector } from '../atomic-components/ConstructionStatusSelector';

export const AssetApprovalPropertyDetails = () => {
  return (
    <LaunchpadCard title={'Property Details'}>
      <NumberOfRoomsTextField />
      <RealestateSizeTextField />
      <BuildingConditionSelector />
      <RealEstatesPropertyTypeSelector />
      <HeatingTypeSelector />
      <CarbonEmissionTextField />
      <EnergyEmissionTextField />
      <AssetFeatureSelector />
      <ConstructionStatusSelector />
    </LaunchpadCard>
  );
};
